import { Link } from "react-router-dom";
import { IMAGES } from "../data/site";

export default function CtaBanner({ title, text, primaryCta, secondaryCta, image }) {
  return (
    <section data-testid="cta-banner" className="bg-[#fdf8ec] py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={image || IMAGES.sfeerTerrace}
              alt=""
              className="w-full h-full object-cover"
              aria-hidden="true"
            />
            {/* Lighter overlay — keep image visible */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#2b1c10]/70 via-[#2b1c10]/40 to-[#ed6a1a]/15" />
          </div>

          <div className="relative px-6 sm:px-12 lg:px-16 py-16 sm:py-20 lg:py-24 max-w-3xl">
            <span className="eyebrow-cream">Mechelen Beach 2026</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.1]">
              {title}
            </h2>
            {text && (
              <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed">
                {text}
              </p>
            )}
            {(primaryCta || secondaryCta) && (
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                {primaryCta && (
                  <Link
                    to={primaryCta.to}
                    data-testid="cta-banner-primary"
                    className="btn-primary"
                  >
                    {primaryCta.label}
                  </Link>
                )}
                {secondaryCta && (
                  <Link
                    to={secondaryCta.to}
                    data-testid="cta-banner-secondary"
                    className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 text-white font-semibold px-7 py-3.5 rounded-full transition-colors"
                  >
                    {secondaryCta.label}
                  </Link>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
